const StarsRating = require('./stars-rating');
const Feedback = require('./feedback');

const StarsRatingAndFeedback = {
  init() {
    StarsRating.init();
    Feedback.init();
  },
};

module.exports = StarsRatingAndFeedback;
